exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveChangeButtonPopup-SaveChangesButton-black_text{color:#000}.SaveChangeButtonPopup-SaveChangesButton-superior_text{color:#fff}", ""]);

// exports
exports.locals = {
	"black_text": "SaveChangeButtonPopup-SaveChangesButton-black_text",
	"superior_text": "SaveChangeButtonPopup-SaveChangesButton-superior_text"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/SaveChangeButtonPopup/SaveChangesButton.css
// module id = 1074
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20